import React from 'react';

import Icon from '../Icon/Icon';

const FilterIcon = (props) => {
    return (
        <Icon width='24' height='24' className='text-primary' {...props}>
            <g>
                <path
                    d='M5 6.7998H19M5 11.9998H19M5 17.1988H19'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9 8.7998C10.1046 8.7998 11 7.90437 11 6.7998C11 5.69524 10.1046 4.7998 9 4.7998C7.89543 4.7998 7 5.69524 7 6.7998C7 7.90437 7.89543 8.7998 9 8.7998Z'
                    fill='currentColor'
                />
                <path
                    d='M9 19.2998C10.1046 19.2998 11 18.4044 11 17.2998C11 16.1952 10.1046 15.2998 9 15.2998C7.89543 15.2998 7 16.1952 7 17.2998C7 18.4044 7.89543 19.2998 9 19.2998Z'
                    fill='currentColor'
                />
                <path
                    d='M15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14Z'
                    fill='currentColor'
                />
            </g>
        </Icon>
    );
};

export default FilterIcon;
